import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import OktaAuth from "@okta/okta-auth-js";
import { AppRoutePaths, AppRoutes } from "./shared/common/app-path.routes";
import { OKTA_AUTH } from "@okta/okta-angular";
import { UsersService } from "./api/users.service";

export const loginGuard: CanMatchFn = async () => {
  const oktaAuth = inject<OktaAuth>(OKTA_AUTH);
  const router = inject(Router);
  const user = inject(UsersService);

  const isAuth = await oktaAuth.isAuthenticated();
  if (isAuth) {
    await user.ensureHydrated();
    router.navigateByUrl(AppRoutePaths[AppRoutes.Dashboard]);
  }
  return true;
};
